import { forwardRef } from "react";
import { Button as MUIButton } from "@mui/material";
import styles from "./button.module.scss";
import actionStyles from "./actionbutton.module.scss";

// eslint-disable-next-line react/display-name
export const EvesButton = forwardRef(
  (
    { isTypeFile, isAction, onChange, children, disabled, ...props }: any,
    ref: any
  ) => {
    return (
      <>
        {!isTypeFile && (
          <MUIButton
            ref={ref}
            className={isAction ? actionStyles.button : styles.button}
            variant="contained"
            size={props.size}
            onClick={props.onClick}
            disabled={disabled}
            {...props}
          >
            {children}
          </MUIButton>
        )}
        {isTypeFile && (
          <MUIButton
            variant="contained"
            className={isAction ? actionStyles.button : styles.button}
            size={props.size}
            disabled={disabled}
            data-cy={props["data-cy"]}
            component="label"
          >
            {children}
            <input
              hidden
              accept=".csv"
              multiple
              type="file"
              onChange={onChange}
            />
          </MUIButton>
        )}
      </>
    );
  }
);
